import './messagebox.scss';
(function ($, Drupal) {
  'use strict';

  function firstLetterLowerCase(text) {
    return text.charAt(0).toLowerCase() + text.slice(1);
  };

  var initialized;
  Drupal.behaviors.tink_messagebox = {
    attach: function (context, settings) {

      // If theres an error in theses form , move the error to the hero
      $('.member-login-form, .user-login-form, .non-member-login-form, #member-activation, #user-pass, .broker-login-form, #broker-manager-form, #broker-manager-delegation-form').find('.form-item--error-message').each(function () {
        let errormessage = $(this).html();

        $('.messagebox').addClass('messagebox-error');
        $('.messagebox .messagebox-text').html( errormessage );
        $('.messagebox').removeClass('d-none');

        $(this).remove();
      });

      if ($('.messagebox-error').length && !initialized) {
        // Theres a bug to add jquery.once in theme.libraries . Instead we are using a variable to only load once
        initialized = true;
        $('.user-login-form, .non-member-login-form, #member-activation, #user-pass, .broker-login-form, #broker-manager-form, #broker-manager-delegation-form').children('.js-form-item').each(function () {
          $(this).addClass('error');

          /* The string 'invalid' isn't added into Drupal.locale.strings for an unknown reason,
           * making it impossible for the Drupal.t() method to translate it.
           */
          if(drupalSettings.path.currentLanguage === "en"){
            $(this).children('label').text(firstLetterLowerCase($(this).children('label').text()));
            $(this).children('label').prepend(Drupal.t('Invalid') + ' ');
          }
          else if(drupalSettings.path.currentLanguage === "fr"){
            $(this).children('label').append(' ' + Drupal.t('invalide'));
          }

          $(this).children('input').addClass('error');
        });
      }
    }
  };
})(jQuery, Drupal);


